import { render, staticRenderFns } from "./WarehouseResortMultipleForm.vue?vue&type=template&id=00d8b8f2&"
import script from "./WarehouseResortMultipleForm.vue?vue&type=script&lang=ts&"
export * from "./WarehouseResortMultipleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports